import { STATES } from '$lib/states';
import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params, fetch }) => {
	const { slug } = params;
	const state = STATES.find((state) => state.slug === slug);
	if (!state) {
		return {
			status: 404
		};
	}

	const { default: stateContent } = await import(`$lib/assets/content/states/${slug}.json`);

	const meta = {
		title: `${stateContent.title || state.name} - Dr. Lotto`,
		description: `${stateContent.description || `${state.name} Lottery`}. Find the best scratch off ticket to buy in ${state.name}. Don't buy a scratchoff ticket that has no remaining grand prizes!`,
		keywords: `${stateContent.keywords || ''}, ${state.name}, lotto, scratchoff, scratch off odds`
	};
	const [gameResponse, stateResponse] = await Promise.all([
		fetch(`https://api.scratchoff-odds.com/games/${slug}`),
		fetch(`https://api.scratchoff-odds.com/states/${slug}`)
	]);

	if (gameResponse.ok && stateResponse.ok) {
		return {
			state,
			gamesData: await gameResponse.json(),
			stateContent,
			stateData: await stateResponse.json(),
			meta
		};
	}

	return {
		status: 500,
		error: new Error(`Failed to fetch data for state ${slug}`)
	};
};
